import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_COMPLAINT_WITHDRAWN_REASONS_FETCH,
} from '../../../actions/actionTypes';

const complaintWithdrawnReasons = fetchReducerGenerator(
  [LINKS_MANAGEMENT_CLEAR],
  LINKS_MANAGEMENT_COMPLAINT_WITHDRAWN_REASONS_FETCH
);

export default complaintWithdrawnReasons;
